module.exports = __webpack_public_path__ + "resource/img/logo-bbi-white.eb5d924d.png";